import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import {
    selectMemoryGameData,
    selectMemoryGameStatus,
    selectMemoryGameError,
    initializeAsync,
} from "./memoryGameSlice";
import { Backdrop, Box, CircularProgress, Container } from "@mui/material";
import { GameList } from "./gameList";
import { useLocation } from "react-router-dom";
import { post } from "../../api";
import InfiniteScroll from "react-infinite-scroll-component";

// Add custom imports here

const MemoryGame = () => {
    const data = useSelector(selectMemoryGameData);
    const status = useSelector(selectMemoryGameStatus);
    const error = useSelector(selectMemoryGameError);
    const dispatch = useDispatch();
    const location = useLocation();
    let records = data.records;

    const [itemData, setItemData] = useState();
    const [loading, setLoading] = useState(true);
    const [noRecordFound, setNoRecordFound] = useState(false);

    const recordsRef = useRef([]);
    const hasMoreRef = useRef(true);
    const lastKeyRef = useRef();
    const initiatedCallRef = useRef(false);

    useEffect(() => {
        loadData("");
    }, [location.pathname]);

    const loadData = (lastKey) => {
        if (hasMoreRef.current && !initiatedCallRef.current) {
            initiatedCallRef.current = true;
            setNoRecordFound(false);
            post("memoryGame/getAllRecords", { lastKey: lastKey, caching: "yes" }).then((result) => {
                if (result.isSuccess) {
                    recordsRef.current = [...recordsRef.current, ...result.data.records];
                    setItemData([...recordsRef.current, ...result.data.records]);
                    if (result.data.lastKey) {
                        hasMoreRef.current = true;
                        lastKeyRef.current = result.data.lastKey;
                    } else {
                        hasMoreRef.current = false;
                    }
                    if (recordsRef.current?.length === 0) {
                        setNoRecordFound(true);
                    }
                }
                if (loading) {
                    setLoading(false);
                }
                initiatedCallRef.current = false;
            });
        }
    };

    const fetchData = () => {
        loadData(lastKeyRef.current);
    };

    let body = (
        <Container sx={{ background: "black", minHeight: "100vh", pt: "0px" }} maxWidth={false} disableGutters>
            <main>
                <Box
                    sx={{
                        bgcolor: "#000",
                        color: "white",
                    }}>
                    <div id="scrollableDiv" style={{ height: "100vh", overflow: "auto", width: "100vw" }}>
                        <InfiniteScroll
                            dataLength={recordsRef.current.length} //This is important field to render the next data
                            next={fetchData}
                            hasMore={true}
                            loader={<h5></h5>}
                            height={"100vh"}
                            endMessage={<p></p>}>
                            <GameList games={recordsRef.current} noRecordFound={noRecordFound}></GameList>
                        </InfiniteScroll>
                    </div>

                    {/* <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop> */}
                </Box>
            </main>
        </Container>
    );

    return getPageContent(body, status, error);
};

export { MemoryGame };
